export default "__VITE_ASSET__Kf__PCz6__"